import React from 'react';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
export function PrivacyPolicyPage() {
  return <main data-id="element-428">
      <SEO title="Privacy Policy" description="Privacy Policy for Ambient Solutions LLC. Learn how we protect your information." data-id="element-429" />
      <PageHero title="Privacy Policy" subtitle="How we protect and manage your information at Ambient Solutions LLC" data-id="element-430" />

      <section className="py-20 px-4 bg-white" data-id="element-431">
        <div className="max-w-3xl mx-auto prose prose-neutral" data-id="element-432">
          <p className="text-neutral-medium mb-8" data-id="element-433">Last Updated: May 2026</p>

          <div className="space-y-12" data-id="element-434">
            <div data-id="element-435">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-436">
                1. Introduction
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-437">
                Ambient Solutions LLC ("we," "our," or "us") is committed to
                protecting your privacy. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                visit our website or use our services.
              </p>
            </div>

            <div data-id="element-438">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-439">
                2. Information We Collect
              </h2>
              <p className="text-neutral-medium leading-relaxed mb-4" data-id="element-440">
                We may collect personal information that you voluntarily provide
                to us when you:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-neutral-medium" data-id="element-441">
                <li data-id="element-442">Fill out a contact form or request a consultation</li>
                <li data-id="element-443">
                  Inquire about our family caregiver certification process
                </li>
                <li data-id="element-444">Sign up for our newsletter or updates</li>
                <li data-id="element-445">Communicate with us via email or phone</li>
              </ul>
            </div>

            <div data-id="element-446">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-447">
                3. How We Use Your Information
              </h2>
              <p className="text-neutral-medium leading-relaxed mb-4" data-id="element-448">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-neutral-medium" data-id="element-449">
                <li data-id="element-450">
                  Provide and manage our home health and caregiver services
                </li>
                <li data-id="element-451">Process background checks and certifications</li>
                <li data-id="element-452">Respond to your inquiries and support requests</li>
                <li data-id="element-453">
                  Send administrative information and marketing communications
                </li>
                <li data-id="element-454">Comply with legal and regulatory requirements</li>
              </ul>
            </div>

            <div data-id="element-455">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-456">
                4. Data Security
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-457">
                We implement appropriate technical and organizational security
                measures to protect the security of any personal information we
                process. However, please also remember that we cannot guarantee
                that the internet itself is 100% secure.
              </p>
            </div>

            <div data-id="element-458">
              <h2 className="text-2xl font-heading font-bold text-neutral-dark mb-4" data-id="element-459">
                5. Contact Us
              </h2>
              <p className="text-neutral-medium leading-relaxed" data-id="element-460">
                If you have questions or comments about this policy, you may
                contact us at:
                <br data-id="element-461" />
                <br data-id="element-462" />
                <strong data-id="element-463">Ambient Solutions LLC</strong>
                <br data-id="element-464" />
                10632 Little Patuxent Parkway
                <br data-id="element-465" />
                Columbia, MD 21044
                <br data-id="element-466" />
                Phone: (866) 652-8987
                <br data-id="element-467" />
                Email: privacy@ambienthomecare.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>;
}